export default function LibraryResultBanner({
  count,
  queryLabel,
  actionLabel,
  onAction,
  kicker,
  style,
}) {
  return (
    <div className="clear-search swatch-view-tile" style={style}>
      <div className="clear-search-card">
        <p className="clear-search-kicker">
          {kicker ?? `${count} results for`}
        </p>
        <p className="clear-search-query">{queryLabel}</p>
        <button
          type="button"
          className="clear-search-action"
          onClick={onAction}
        >
          <span>{actionLabel}</span>
        </button>
      </div>
    </div>
  );
}
